function initMaisVendidosSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initMaisVendidosSwiper, 100);
    return;
  }

  document.querySelectorAll('.mais-vendidos-grid').forEach((el) => {
    if (el.classList.contains('swiper-initialized')) return;

    const slideCount = el.querySelectorAll('.mais-vendidos-card-wrapper').length;
    const dotsContainer = el.closest('.mais-vendidos-grid-wrapper').querySelector('[data-dots-container]');
    const prevBtn = el.closest('.mais-vendidos-grid-wrapper').querySelector('[data-slide-prev]');
    const nextBtn = el.closest('.mais-vendidos-grid-wrapper').querySelector('[data-slide-next]');

    const swiper = new Swiper(el, {
      loop: slideCount > 4,
      spaceBetween: 16,
      slidesPerView: 1.2,
      observer: true,
      observeParents: true,
      breakpoints: {
        500: { slidesPerView: 2 },
        800: { slidesPerView: 3 },
        1250: { slidesPerView: 4 }
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      }
    });

    if (dotsContainer) {
      const maxBullets = 4;
      const totalBullets = Math.min(slideCount, maxBullets);

      dotsContainer.innerHTML = '';
      const bullets = [];

      for (let i = 0; i < totalBullets; i++) {
        const bullet = document.createElement('button');
        bullet.className = 'mais-vendidos-dot' + (i === 0 ? ' active' : '');
        bullet.setAttribute('aria-label', `Slide ${i + 1}`);
        dotsContainer.appendChild(bullet);
        bullets.push(bullet);

        bullet.addEventListener('click', () => {
          const currentRealIndex = swiper.realIndex;
          let targetIndex = i;
          let minDiff = Infinity;
          for (let s = 0; s < slideCount; s++) {
            if (s % totalBullets === i) {
              const diff = Math.abs(s - currentRealIndex);
              if (diff < minDiff) {
                minDiff = diff;
                targetIndex = s;
              }
            }
          }
          swiper.slideToLoop(targetIndex);
        });
      }

      swiper.on('slideChange', () => {
        const realIndex = swiper.realIndex;
        const activeBulletIndex = realIndex % totalBullets;

        bullets.forEach((b, idx) => {
          if (idx === activeBulletIndex) {
            b.classList.add('active');
          } else {
            b.classList.remove('active');
          }
        });
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', initMaisVendidosSwiper);
document.addEventListener('shopify:section:load', initMaisVendidosSwiper);
